import React from 'react';
import styled from 'styled-components';

import { useCountdown } from '../../hooks/use-countdown';

interface CountdownTimerProps {
  targetDate: number | string;
  timezone?: string;
  sm?: boolean;
}

export const CountdownTimer: React.FC<CountdownTimerProps> = ({
  targetDate,
  timezone,
  sm = false,
}) => {
  const { minutesL, minutesR, secondsL, secondsR, diffInSeconds } = useCountdown({
    targetDate,
    timezone,
  });

  if (diffInSeconds <= 0) {
    return (
      <NumbersWrapper>
        <StyledNumber sm={sm}>0</StyledNumber>
        <StyledNumber sm={sm}>0</StyledNumber>
        <StyledSeparator>:</StyledSeparator>
        <StyledNumber sm={sm}>0</StyledNumber>
        <StyledNumber sm={sm}>0</StyledNumber>
      </NumbersWrapper>
    );
  } else {
    return (
      <NumbersWrapper>
        <StyledNumber sm={sm}>{minutesL}</StyledNumber>
        <StyledNumber sm={sm}>{minutesR}</StyledNumber>
        <StyledSeparator>:</StyledSeparator>
        <StyledNumber sm={sm}>{secondsL}</StyledNumber>
        <StyledNumber sm={sm}>{secondsR}</StyledNumber>
      </NumbersWrapper>
    );
  }
};

const NumbersWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

interface StyledNumberProps {
  sm: boolean;
}

const StyledNumber = styled.div<StyledNumberProps>`
  display: flex;
  padding: 8px 12px;
  margin: ${({ sm }) => (sm ? `0 2px` : `0 4px`)};
  width: 39px;
  align-items: center;
  justify-content: center;
  background: ${({ theme, sm }) => (sm ? theme.colors.white : theme.colors.backgroundLight)};
  border-radius: 12px;
  font-family: 'Baloo 2';
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
  justify-content: center;

  @media screen and (max-width: ${({ theme }) => theme.screenSizes.xs}) {
    padding: 8px 6px;
    width: 30px;
  }
`;

const StyledSeparator = styled.div`
  font-family: 'Baloo 2';
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #000000;
`;
